// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__28hj3","label":"Category_label__1oLw8","content":"Category_content__2l1SV","header":"Category_header__3PhSU","location":"Category_location__SmSKW"};